/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaDivisionesTiposPropiedadesVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaDivisionesTiposPropiedades: React.FunctionComponent<ITablaDivisionesTiposPropiedadesVistaProps &
    InjectedIntlProps> = ({
    divisionesTiposPropiedadess,
    cargarDivisionesTiposPropiedades,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={divisionesTiposPropiedadess}
            actions={acciones(
                manejarFormulario,
                cargarDivisionesTiposPropiedades,
                intl.formatMessage,
                confirmarEliminacion
            )}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaDivisionesTiposPropiedades);
